import {
    Box,
    Flex,
    Image,
    Step,
    StepDescription,
    StepIndicator,
    StepSeparator,
    StepStatus,
    StepTitle,
    Stepper,
    Text,
    Textarea,
  } from "@chakra-ui/react";
  import React, { useEffect, useRef, useState } from "react";
import { AddROSCall, FetchReviewSystemsDetails } from "../../middleware/services/messages";
import moment from "moment";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import { useLocation } from "react-router-dom";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import { DropdownInput, PrimaryButton, PrimaryInput, Toaster } from "../../components";
import DynamicModal from "../../components/dynamic-modal";
import { FetchDoctorsByUser, FetchUsersByClinic } from "../../middleware/services/home";
import { getIsDoctor, getLoginID } from "../../auth";
import { useForm } from "react-hook-form";
import { CorrectChiefComplaintUsingAI, CorrectMedicalTermsUsingAI } from "../../middleware/services/visits/aicalls";
import { useGPUTranscriber } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/useGPUTranscriber";
import DatePicker from "../../components/date-picker";
import { GPUChatAudioManager } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/gpuChatVoiceManager";
import DoctorROSCard from "../../components/patient-health/doctor-notes/ros-card";
import { useHybridTranscriber } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/useHybridTranscriber";
import { GPUChatAudioManagerSpeechMode } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/gpuChatVoiceManagerSpeechMode";


const ReviewSystem = ({id, backFunction}) => {

  const location = useLocation();
  const [patientid, setPatientid] = useState("");
  const [apmtIdUrl, setApmtIdUrl] = useState("");
  const [rosData, setRosData] = useState(null);
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const { showSuccessToast, showErrorToast } = Toaster();

  useEffect(() => {
    const currentUrl = window.location.href;
    const searchParams = new URLSearchParams(currentUrl.split('?') [1]);
    const id = searchParams.get('id');
    const apmtid = searchParams.get('appointmentid');
    setPatientid(id);

    if (apmtid) {
    setApmtIdUrl(apmtid);
  }

  if(apmtid) {
      fetchreviewsystemdata(id, apmtid)
    } else {
      fetchreviewsystemdata(id, "")
    }
    // fetchreviewsystemdata(id)   
  }, []);
  
  const fetchreviewsystemdata = async (id, apmtid="") => {
    showLoader()
        try {
          const result = await FetchReviewSystemsDetails({
            patientid: id,
            ...(apmtid && { appointmentid: apmtid }), 
            ...(apmtid && { type: 'ipd' })
          });

          // console.log(result, "pagessss review")

          if (result != null) {
            console.log(result)
            setRosData(result);
          } else {
            setRosData('')
          }
          dismissLoader()
      } catch (error) {
          console.error("Error in home:", error);
        }
      };

      const formatDate = (dateString) => {
        if (!dateString) return "-";
        return moment(dateString).format("Do MMM, YYYY");
      };

      // console.log(patientid, "ROS IDDDDD")
      // console.log(rosData, "ROS Dataaaaaaa")
  
  // ---------------------------- Add & Edit Functionality-----------------------------------------
  const addROS = React.useRef();
  const editROS = React.useRef();
  var [DoctorListForDropdown, setDoctorListForDropdown] = useState([]);
  var [DoctorList, setDoctorList] = useState([]);
  var [Doctorid, setDoctorid] = useState(null);
  var [DefaultDoctor, setDefaultDoctor] = useState(null);
  const [addROSText, setAddROSText] = useState('')
  const [editROSText, setEditROSText] = useState('')
  
    const { register, handleSubmit, watch, setValue } = useForm();
    const textFieldValue = watch("textField", "");
      const [isButtonDisabled, setIsButtonDisabled] = useState(false);
      const [initialText, setInitialText] = useState("");
  
      const [addDate, setAddDate] = useState(null);
      const [addDocId, setAddDocId] = useState(null);
      
  
  const [date, setDate] = useState(moment().format("DD-MM-yyyy"));
  const [time, setTime] = useState(moment().format("HH:mm"));
  
  const getLocalISOString = (dateStr, timeStr) => {
    // Parse the date in DD-MM-yyyy format
    const [day, month, year] = dateStr.split("-").map(Number);
    // Parse the time in HH:mm format
    const [hours, minutes] = timeStr.split(":").map(Number);
    
    // Create a Date object in local timezone
    const dateObj = new Date(year, month - 1, day, hours, minutes, 0);
    
    // Format to ISO string with local timezone offset
    const timezoneOffset = dateObj.getTimezoneOffset() * 60000; // offset in milliseconds
    const localISOTime = new Date(dateObj - timezoneOffset).toISOString().slice(0, 19).replace('Z', '');
    
    return localISOTime;
  };
  
  const handledatechange = (selectedDate) => {
    const formattedDate = moment(selectedDate).format("DD-MM-yyyy");
    setDate(formattedDate);
  };
  
  const handleTimeChange = (event) => {
    const inputTime = event.target.value;
    const currentDate = moment().format("DD-MM-yyyy");
    const currentTime = moment().format("HH:mm");
    
    // Only validate if the selected date is today
    if (date === currentDate) {
      const [inputHours, inputMinutes] = inputTime.split(":").map(Number);
      const [currentHours, currentMinutes] = currentTime.split(":").map(Number);
  
      // Create moment objects for comparison
      const inputMoment = moment().set({
        hour: inputHours,
        minute: inputMinutes,
        second: 0,
        millisecond: 0
      });
      
      const currentMoment = moment();
  
      if (inputMoment.isAfter(currentMoment)) {
        setTime(currentTime);
        showErrorToast("Future time cannot be selected.");
        return;
      }
    }
    
    // If date is not today or time is not in future, update the time
    setTime(inputTime);
  };
  
  const handleEditTimeChange = (event) => {
    const inputTime = event.target.value;
    const currentDate = moment().format("DD-MM-yyyy");
    const currentTime = moment().format("HH:mm");
    
    // Only validate if the selected date in edit modal is today
    if (editROSData.date === currentDate) {
      const [inputHours, inputMinutes] = inputTime.split(":").map(Number);
      const [currentHours, currentMinutes] = currentTime.split(":").map(Number);
  
      // Create moment objects for comparison
      const inputMoment = moment().set({
        hour: inputHours,
        minute: inputMinutes,
        second: 0,
        millisecond: 0
      });
      
      const currentMoment = moment();
  
      if (inputMoment.isAfter(currentMoment)) {
        const currentFormattedTime = moment().format("HH:mm");
        setEditROSData(prev => ({...prev, time: currentFormattedTime}));
        showErrorToast("Future time cannot be selected.");
        return;
      }
    }
    
    // If date is not today or time is not in future, update the time
    setEditROSData(prev => ({...prev, time: inputTime}));
  };

  // existing functions
  // const handleTimeChange = (event) => {
  //   const inputTime = event.target.value;
  //   const currentTime = new Date();
  //   const [inputHours, inputMinutes] = inputTime.split(":").map(Number);
  
  //   const inputDate = new Date();
  //   inputDate.setHours(inputHours);
  //   inputDate.setMinutes(inputMinutes);
  
  //   if (inputDate > currentTime) {
  //     const currentFormattedTime = moment().format("HH:mm");
  //     setTime(currentFormattedTime);
  //     showErrorToast("Future time cannot be selected.");
  //   } else {
  //     setTime(inputTime);
  //   }
  // };
  // const handleEditTimeChange = (event) => {
  //   const inputTime = event.target.value;
  //   const currentTime = new Date();
  //   const [inputHours, inputMinutes] = inputTime.split(":").map(Number);
  
  //   const inputDate = new Date();
  //   inputDate.setHours(inputHours);
  //   inputDate.setMinutes(inputMinutes);
  
  //   if (inputDate > currentTime) {
  //     const currentFormattedTime = moment().format("HH:mm");
  //     setEditROSData(prev => ({...prev, time: currentFormattedTime}));
  //     showErrorToast("Future time cannot be selected.");
  //   } else {
  //     setEditROSData(prev => ({...prev, time: inputTime}));
  //   }
  // };
  
  const addROSData = () => {
    // Clear the instructions properly
    // setInstructions("");
    setPlaceholder("Click anywhere to start typing....")
    setValue("textField", ""); // Clear the form value
    setAddROSText('')
    setDate(moment().format("DD-MM-yyyy"));
    setTime(moment().format("HH:mm"));
    fetchDoctors();
    addROS.current.openModal();
    // setShowDocNamesDropdown(false)
  } 
  
  // const openEditROSModal = (item) => {
  //   console.log('item: ', item)
  //   setPlaceholder("Click anywhere to start typing....")
  //   setValue("textField", ""); // Clear the form value
  //   setAddROSText('')
  //   setDate(moment().format("DD-MM-yyyy"));
  //   setTime(moment().format("HH:mm"));
  //   fetchDoctors();
  //   editROS.current.openModal();
  //   // setShowDocNamesDropdown(false)
  // } 
  

  // Function to extract comma-separated specialties from doctorspeciality array
  const getCommaSeparatedSpecialties = (specialtiesArray) => {
    if (!specialtiesArray || !Array.isArray(specialtiesArray)) {
      return "";
    }
    
    // Extract specialityname from each object and filter out null/undefined values
    const specialtyNames = specialtiesArray
      .map(specialty => {
        if (specialty?.specialityname === "Other" && specialty?.othervalue) {
          // Use othervalue when specialityname is "Other" and othervalue exists
          return specialty.othervalue;
        } else {
          // Use specialityname for all other cases
          return specialty?.specialityname;
        }
      })
      .filter(name => name != null && name.trim() !== "");
    
    return specialtyNames.join(", ");
  };
  
  const [doctorSpecialties, setDoctorSpecialties] = useState("");
  // Updated fetchDoctors function with specialty handling
  const fetchDoctors = async () => {
    showLoader();
    try {
      const result = await FetchUsersByClinic({
        appointmentid: apmtIdUrl,
      });
  
      if (result.output.result == "success") {
        console.log('result.output.data: ', result.output.data);
        
        // Process doctors with specialties
        const processedDoctors = result.output.data.map(doctor => ({
          ...doctor,
          specialtiesString: getCommaSeparatedSpecialties(doctor.doctorspeciality)
        }));
        
        setDoctorList(processedDoctors);
        
        const Doctors = processedDoctors.map((doctor) => [
          doctor.fullname
        ]);
        console.log('Doctors: ', Doctors);
        setDoctorListForDropdown(Doctors);
        
        const currentdoctor = getIsDoctor();
        console.log('currentdoctor: ', currentdoctor);
        const loginid = getLoginID();
        console.log('getLogin: ', loginid);
        
        let obj = {};
        if (currentdoctor == 1 && currentdoctor != null) {
          obj = processedDoctors.filter(doctor => doctor.doctorid == loginid);
          if (obj[0]) {
            console.log('obj[0]: ', obj[0].fullname);
            setDefaultDoctor(obj[0].fullname);
            setDoctorid(loginid);
            // Set specialties for the current doctor
            setDoctorSpecialties(obj[0].specialtiesString);
          }
        } else {
          setDefaultDoctor("");
          // Reset specialties if no current doctor
          setDoctorSpecialties("");
        }
      } else {
        setDoctorList([]);
        dismissLoader();
      }
      dismissLoader();
    } catch (error) {
      console.error("Error", error);
    }
  };

  // const fetchDoctors = async () => {
  //     showLoader();
  //     try {
  //       // const result = await FetchDoctorsByUser({
  //       const result = await FetchUsersByClinic({
  //         // doctorid,
  //         appointmentid: apmtIdUrl,
  //       });
  
  //       // console.log('resultofDoctors: ', result)
  //       if (result.output.result == "success") {
  //         console.log('result.outptu.data: ', result.output.data)
  //         setDoctorList(result.output.data);
  //         const Doctors = result.output.data && result.output.data.map((step) => [
  //           step.fullname
  //         ]);
  //         console.log('Doctors: ', Doctors)
  //         setDoctorListForDropdown(Doctors);
  //         const currentdoctor = getIsDoctor();
  //         console.log('currentdoctor: ', currentdoctor)
  //         const loginid = getLoginID();
  //         console.log('getLogin: ', loginid)
          
  //         let obj = {}
  //         if (currentdoctor == 1 && currentdoctor != null) {
  //           obj = result.output.data && result.output.data.filter(doctor => doctor.doctorid == loginid);
  //           if (obj[0]) {
  //             console.log('obj[0]: ', obj[0].fullname)
  //             setDefaultDoctor(obj[0].fullname)
  //             setDoctorid(loginid)
  //           }
  
  //         } else {
  //           setDefaultDoctor("");
  //         }
  //       } else {
  //         setDoctorList([]);
  //         dismissLoader();
  //       }
  //       dismissLoader();
  //     } catch (error) {
  //       console.error("Error", error);
  //     }
  //   };

const HandleAddDoctor = (selectedOption) => {
    let obj = DoctorList.filter(doctor => doctor.fullname == selectedOption);
    // setDoctorid(obj[0].doctorid)
    if (obj.length > 0) {
    setDoctorid(obj[0].doctorid);
    // setSelectedDoctorId(obj[0].doctorid); // Store the selected doctor ID
    setDefaultDoctor(obj[0].fullname);

    setDoctorSpecialties(obj[0].specialtiesString);
  }
  }
  
  const HandleEditDoctor = (selectedOption) => {
      let obj = DoctorList.filter(doctor => doctor.fullname == selectedOption);
      // setDoctorid(obj[0].doctorid)
      if (obj.length > 0) {
      // setDoctorid(obj[0].doctorid);
      // // setSelectedDoctorId(obj[0].doctorid); // Store the selected doctor ID
      // setDefaultDoctor(obj[0].fullname);

      // Also update the editHPIData with the new doctor info
    setEditROSData(prev => ({
      ...prev,
      doctorid: obj[0].doctorid,
      doctorname: obj[0].fullname,
      doctorspecialties: obj[0].specialtiesString
    }));
    // Also update the global doctorSpecialties state
    setDoctorSpecialties(obj[0].specialtiesString);
    }
    }
  
  //const activeTranscriber = useGPUTranscriber();
  //Remove speech and keep Null to toggle between GPU and Speech
  const { transcriber: activeTranscriber, mode } =
    useHybridTranscriber("speech", (text) => {
      // called when speech recognition finishes
      setPlaceholder(text || "");
      setTyping(false);
  });
    
    const [typing, setTyping] = useState(false); // Typing indicator state
    const [ROSTextBox, setROSTextBox] = useState("");
  
    const [placeholder, setPlaceholder] = useState(
      "Click anywhere to start typing...."
    );
  
    useEffect(() => {
      if (activeTranscriber?.output?.text) {
    const transcribedText = activeTranscriber.output.text;
    setValue("textField", transcribedText);
    // setAddGeneralDoctorNotes(transcribedText); // Update the state with transcribed text
    // setPlaceholder("Click anywhere to start typing...."); // Clear the placeholder when text exists
    setAddROSText(transcribedText); // Add this line to update addHPIText state
    setPlaceholder("");
    setTyping(false);
  }
      }, [activeTranscriber?.output]);
  
      // Handle text changes in the textarea
  const handleTextChange = (e) => {
    const text = e.target.value;
    setAddROSText(text);
    setValue("textField", text); // Keep form value in sync
    setPlaceholder(text ? "" : "Click anywhere to start typing...."); // Show placeholder only when empty
  };
  const handleEditTextChange = (e) => {
    const text = e.target.value;
    setEditROSText(text);
    setValue("textField", text); // Keep form value in sync
    setPlaceholder(text ? "" : "Click anywhere to start typing...."); // Show placeholder only when empty
  };
  
    const onSubmit = (data) => {
        setIsButtonDisabled(true); // Disable button on submit
        // UpdateHpiTextBox(data);
        setROSTextBox(data);
        // fetchDoctorNotesEmptyIndication();
      };
    
        // submit on tab switch and submit button is enalbed
        useEffect(()=>{
            if(!isButtonDisabled){
            handleSubmit(onSubmit)();
            }
        },[])
    
      useEffect(() => {
        if (textFieldValue !== initialText) {
          setIsButtonDisabled(false); // Enable button if text field value changes
        } else {
          setIsButtonDisabled(true); // Disable button if text field value is unchanged
        }
      }, [textFieldValue, initialText]);
  
      const correctOrders = async (formType) => {
          const currentText = watch("textField");
          
          if (!currentText) {
            showErrorToast("No text available to correct");
            return;
          }
      
          // const inputToSave = {
          //   input: {
          //     text: currentText,
          //   },
          // };
          console.log('ros specialites: ', doctorSpecialties)
          const inputToSave = {
            input: {
              text: currentText,
              // type: `ros#${doctorSpecialties}#${noteType}#${doctorExperience}#${inpLang}#${outLang}`,
              type: "ROS"
            },
          };
      
          showLoader();
          try {
            // const result = await CorrectChiefComplaintUsingAI(inputToSave.input);
            const result = await CorrectMedicalTermsUsingAI(inputToSave);
            if (result) {
              showSuccessToast("Updated Text");
              const updatedText = result?.text;
      
              // Update form value
              setValue("textField", updatedText, {
                shouldDirty: true,
                shouldTouch: true,
                shouldValidate: true,
              });
      
      console.log('updatedText: ', updatedText)
              
              // Update the appropriate state based on form type
              if (formType === "add") {
                setAddROSText(updatedText);
              } else {
                // handleEditMedicineChange("custommessage", updatedText);
                setEditROSText(updatedText);
              }
              
            setPlaceholder("");
              setIsButtonDisabled(false);
            }
          } catch (error) {
            console.error("Error in Correct AI call:", error);
            // showErrorToast("Error Happened While Correcting.");
            showErrorToast("Error in Correct AI call.");
          } finally {
            dismissLoader();
          }
      };
  
    const handleHPISubmission = async () => {
    if (!Doctorid) {
      showErrorToast("Please select a doctor");
      return;
    }
  
    if (!addROSText || addROSText.trim() === "") {
      showErrorToast("Please enter HPI text");
      return;
    }
  
    const inputToSave = {
      input: {
        appointmentid: apmtIdUrl, 
        patientid: patientid,
        updatedby: Doctorid,
        updateddate: getLocalISOString(date, time),
        rostext: [
          {
            type: "other", 
            description: addROSText,
            id: null,
            updatedby: Doctorid,
            updateddate: getLocalISOString(date, time)
          }
        ]
      }
    };
  
    showLoader();
    try {
      const result = await AddROSCall(inputToSave.input); 
      if (result.output.result === "success") {
        // fetchhistoryillnessdata(patientid)
        if(apmtIdUrl) {
          fetchreviewsystemdata(patientid, apmtIdUrl)
        }else {
          fetchreviewsystemdata(patientid)
  
        }
        showSuccessToast("ROS added successfully");
        addROS.current.closeModal();
      }
    } catch (error) {
      console.error("Error adding HPI:", error);
      showErrorToast("Error adding HPI");
    } finally {
      dismissLoader();
    }
  };

  const [editROSData, setEditROSData] = useState({
  id: null,
  rosname: '',
  rostext: '',
  date: moment().format("DD-MM-yyyy"),
  time: moment().format("HH:mm"),
  doctorid: null,
  doctorname: ''
});

const openEditROSModal = (item) => {
  console.log('item: ', item);
  
  // Parse the date from the item
  const itemDate = moment(item.updateddate || item.DATE).format("DD-MM-yyyy");
  const itemTime = moment(item.updateddate || item.DATE).format("HH:mm");

  setEditROSData({
    id: item.id,
    rosname: item.rosname,
    rostext: item.description,
    date: itemDate,
    time: itemTime,
    doctorid: item.doctorid,
    doctorname: item.doctorname
  });

  setValue("textField", item.rostext || "");
  setEditROSText(item.rostext || "");
  setPlaceholder(item.rostext ? "" : "Click anywhere to start typing....");
  setDefaultDoctor(item.doctorname);
  setDoctorid(item.doctorid);
  fetchDoctors();
  
  editROS.current.openModal();
};

  const handleROSSubmission = async () => {
  // if (!Doctorid) {
  //   showErrorToast("Please select a doctor");
  //   return;
  // }
  if (!editROSData.doctorid) { // Use editHPIData.doctorid instead of Doctorid
    showErrorToast("Please select a doctor");
    return;
  }

  if (!editROSText || editROSText.trim() === "") {
    showErrorToast("Please enter ROS text");
    return;
  }

  const inputToSave = {
    input: {
      id: editROSData.id, 
      appointmentid: apmtIdUrl, 
      patientid: patientid,
      // updatedby: Doctorid,
      updatedby: editROSData.doctorid,
      updateddate: getLocalISOString(date, editROSData.time),
      rostext: [
        {
          "type": 'other',
          description: editROSText,
          id: editROSData.id,
          // updatedby: Doctorid,
          updatedby: editROSData.doctorid,
          updateddate: getLocalISOString(date, editROSData.time),
        }
      ],
      // rosname: editROSData.rosname 
    }
    // input: {
    //   id: editROSData.id, 
    //   appointmentid: apmtIdUrl, 
    //   patientid: patientid,
    //   updatedby: Doctorid,
    //   updateddate: getLocalISOString(date, time),
    //   rostext: editROSText,
    //   rosname: editROSData.rosname 
    // }
  };

  showLoader();
  try {
    const result = await AddROSCall(inputToSave.input); 
    if (result.output.result === "success") {
      showSuccessToast("ROS updated successfully");
      if(apmtIdUrl) {
        fetchreviewsystemdata(patientid, apmtIdUrl);
      } else {
        fetchreviewsystemdata(patientid);
      }
      editROS.current.closeModal();
    }
  } catch (error) {
    console.error("Error updating ROS:", error);
    showErrorToast("Error updating ROS");
  } finally {
    dismissLoader();
  }
};

const deleteModal = useRef();
const [deleteId, setDeleteId] = useState(null)
const openDeleteModal = (id) => {
      setDeleteId(id);
      deleteModal.current.openModal();
    };

    const handleConfirmDelete = async () => {
      if (!deleteId) return;

      const input = {
        // doctorid: doctorId,
        patientid: patientid,
        appointmentid: apmtIdUrl,
        id: deleteId,
        isactive: 0,
      //   rostext: [{
      // }]
      };

      showLoader();
      try {
        const req = await AddROSCall(input);
        if (req.output.result === "success") {
          if (apmtIdUrl) {
            await fetchreviewsystemdata(patientid, apmtIdUrl);
          } else {
            await fetchreviewsystemdata(patientid);
          }
          showSuccessToast("ROS deleted successfully.");
          deleteModal.current.closeModal();
          setDeleteId(null);
        } else {
          showErrorToast("Failed to delete ROS.");
        }
      } catch (error) {
        console.error("Error deleting ROS:", error);
        showErrorToast("Error deleting the ROS.");
      } finally {
        dismissLoader();
      }
    };

      return (
        <>
        {isLoading && <Loader />}
          <Box w="100%" display={{base: "none", lg: "block"}}>
            {apmtIdUrl && (
             <Box pos='sticky' p='1rem 1.5rem' alignItems='center' top='0' zIndex='999' bg='white' borderBottom='1px solid #E6E7E9' display="flex" justifyContent="space-between" mb="10px">
                        <Text fontWeight='600'>Review of System</Text>
                        <PrimaryButton
                          fontSize="14px"
                          variant="mdBtn"
                          btnIcon="/assets/imgs/add.png"
                          buttonText="Add ROS"
                          onClick={addROSData}
                          // isDisabled={actionAccessPatients?.create ? false : true}
                        />
                      </Box>
            )}
            <Stepper
              orientation="vertical"
          // height="400px"
          height='calc(100vh - 160px)'
          overflow='hidden auto'
          padding='1rem'
          size="xs"
          colorScheme="#CDCFD4"
          // gap="0"
          gap="1rem"
          w="100%"
           justifyContent='flex-start'
              // orientation="vertical"
              // height="100%"
              // size="xs"
              // colorScheme="#CDCFD4"
              // gap="0"
              // w="100%"
            >
              {rosData && rosData.length>0 ? (
                  rosData.map((ros,index) => (
                <Step key={index} flex='unset' w="100%" >
                  <StepIndicator color="#E6E7E9" />
                  <Box flexShrink="0" w="95%" key={index}>
                    {/* <StepTitle fontSize="0.75rem" fontWeight="500" color="#384052" mb="0.5rem">
                      {ros.DATE ? formatDate(ros.DATE) : ('-')}
                    </StepTitle> */}

                    <StepTitle as="div">
                      <Box display='flex' gap='1rem'>
                    <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{ros.updateddate ? formatDate(ros.updateddate) : formatDate(ros.DATE)}</Text>
                    {apmtIdUrl && (
                      <Box w='fit-content'>
                        {ros.iscurrentvisit == 1 ? (
                          <Text
                          fontSize="0.75rem"
                          borderRadius="full"
                          fontWeight="600"
                          p="0.25rem 0.5rem"
                          border="1px solid #E6E7E9"
                          // bg='#14C585'
                          // bg="#E6E7E966"
                          // color='rgb(0,151,0)'
                          bg='rgb(16, 185, 129)'
                        >
                          Current
                        </Text>
                        ) : (
                          <Text
                            fontSize="0.75rem"
                            borderRadius="full"
                            fontWeight="600"
                            p="0.25rem 0.5rem"
                            border="1px solid #E6E7E9"
                            // bg="#E6E7E966"
                            // color='rgb(255,165,0)'
                            // bg="rgb(255,165,0)"
                            // color="#E6E7E966"
                            bg="rgb(214, 158, 46)"
                          >
                            Past
                          </Text>
                        )}
                        </Box>
                      )}
                      </Box>
                    <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{`${ros.doctorname} , ${ros.bookingid}`}</Text>
                    <Text fontSize="0.875rem" color="#384052" mb="0.5rem">{ros.specialization}</Text>
                  </StepTitle>
                    <StepDescription
                      bg="white"
                      w="100%"
                      border="1px solid #E6E7E9"
                      borderRadius="0.65rem"
                      p="0.75rem"
                      mb="1.5rem"
                      boxShadow="0px 8px 20px 0px #E6E7E966"
                    >
                      <Flex justifyContent="space-between" alignItems="center" w="100%">
                      <Box display="flex" alignItems="center" gap="0.5rem" flexWrap="wrap">

                      <Text fontSize="0.625rem" w="max-content" fontWeight="600" color="#384052" p="0.25rem 0.5rem" bg="#E6E7E966" border="1px solid #E6E7E9" borderRadius="full">
                        {/* Alive */}
                        {ros.rosname}
                      </Text>
                      {/* existing */}
                      {/* {ros.rosvalue && ros.rosvalue.length>0 ? (
                        ros.rosvalue.map((item,subIndex) => (
                        <Text fontSize="0.875rem" color="#061027" key={subIndex}>
                        {item.value}
                        </Text>

                        ))
                      ) : ('NULL')} */}
                      {ros.rosvalue?.length > 0 ? (
  ros.rosvalue.map((item, subIndex) => (
    <Text fontSize="0.875rem" color="#061027" key={subIndex}>
      {item.value}
    </Text>
  ))
) : ros.rostext ?? 'NULL'}
                      </Box>
                        {ros.iscurrentvisit === 1 && (
                    <Box display="flex" gap="1.5rem" mr='1rem' cursor='pointer'>
                      <Box as="button" 
                      // disabled={actionAccessPatients?.update ? false : true}
                      // opacity={actionAccessPatients?.update ? 1 : 0.5} 
                      >
                        <Image 
                        src="/assets/svgs/edit.svg" 
                        w='1rem'
                        h='auto'
                        onClick={() => openEditROSModal(ros)} 
                        />
                        </Box>
                        <Box as="button" 
                        // disabled={actionAccessPatients?.delete ? false : true}
                        // opacity={actionAccessPatients?.delete ? 1 : 0.5} 
                        >
                        <Image 
                        src="/assets/svgs/delete.svg"
                        w='14px'
                        h='auto'
                        onClick={() => openDeleteModal(ros.id)}
                        />
                        </Box>
                    </Box>
                    )}
                      </Flex>
                    </StepDescription>
                  </Box>

    
                  <StepSeparator colorScheme="red" />
                </Step>
                  ))

              ) : (
                <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            gap="10px"
                            alignItems="center"
                            h="calc(100vh - 100px)"
                            w="100%"
                          >
                            <Box textAlign="left" fontSize="16px" fontWeight="600">
                              <Image
                                w="26px"
                                opacity="0.5"
                                src="/assets/imgs/protection.png"
                              />
                            </Box>
                            <Text textAlign="left" fontSize="12px" fontWeight="500">
                              No Data available
                            </Text>
                          </Box>
              )}
            </Stepper>
          </Box>

{/* Add HOPI */}
  <DynamicModal
    ref={addROS}
    modalHeader={`Add ROS`}
    modalWidth='600px'
    modalBody={
      <>
        {/* <Box display="flex" py="20px">  */}
        <Box display="flex"> 
          <DatePicker
            onDateChange={(selectedDateValue) =>
              handledatechange(selectedDateValue)
            }
            defaultDate={date}
            disableFutureDates={true}
            placeholderProp="Date"
            calendarStlye={{left: "-18px",  right: "unset"}}
          />
          <PrimaryInput
            variant="bothSide"
            id="vitaltime"
            inputType="time"
            inputPlace="Time"
            pr="10px"
            defaultValue={time}
            inputValue={time}
            onChange={handleTimeChange }
          />
        </Box>
        <Box display="flex" flexDir="column">
          <DropdownInput
            variant="bothSide"
            dropDownPlace="Doctor Name*"
            options={DoctorListForDropdown?DoctorListForDropdown:""}
            id="Doctor Name"
            onClick={HandleAddDoctor}
            value={DefaultDoctor} 
            defaultOption={DefaultDoctor}
            menuList={{ pos: "absolute", right: "-41px", minW: "310px" }}
            inputStyleCss={{ w: "100%" }}
          />
        </Box>

        {/* <DoctorROSCard
          patientId={patientid}
          doctorId={getLoginID()}
          appointmentId={apmtIdUrl}
          showSuccessToast={showSuccessToast}
          showErrorToast={showErrorToast}
          showLoader={showLoader}
          dismissLoader={dismissLoader}
          // fetchDoctorNotesEmptyIndication={
          //   fetchDoctorNotesEmptyIndication
          // }
          // submitOnTabSwitch={submitRosTab}
        /> */}

        <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
          <Box
            as="form"
            width='100%'
            bg="white"
            pt={"2px"}
          >
            <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
              <Textarea
                borderRadius='0'
                // placeholder="Instructions"
                {...register("textField")}
                // inputValue={addROSText}
                value={addROSText}
                onChange={handleTextChange}
                height="100%"
                padding="2"
                resize="none"
                // disabled={typing} // Disable when AI typing is true
                style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
              />
              
              {!addROSText && (
                <Text
                  position="absolute"
                  bottom="2"
                  left="50%"
                  transform="translateX(-50%)"
                  fontSize="sm"
                  color="gray.500"
                  w={{ base: "100%", md: "unset" }}
                  textAlign={{ base: "center", md: "unset" }}
                >
                  {placeholder}
                </Text>
              )}
            </Box>
          </Box>
        </Box>
      </>
    }
    modalFooterBtn={
      <>
      <GPUChatAudioManagerSpeechMode
                  transcriber={activeTranscriber}
                  mode={mode}
                  setPlaceholder={setPlaceholder}
                  setTyping={setTyping}
                />
            <Box
              as="button"
              type="button" // Prevent form submission
              border="1px solid #E6E7E9"
              borderRadius="full"
              w="36px"
              h="auto"
              p="10px"
              mr='10px'
              display="flex"
              justifyContent="center"
              alignItems="center"
              cursor={textFieldValue ? "pointer" : "not-allowed"}
              opacity={textFieldValue ? 1 : 0.5}
              pointerEvents={textFieldValue ? "auto" : "none"}
              onClick={() => textFieldValue && correctOrders("add")}
            >
              <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
            </Box>
        <PrimaryButton
          // variant="deleteBtn"
          buttonText="Add ROS"
          btnStyle={{
            w: "100%",
            h: "2.5rem",
          }}
          onClick={() => {
            handleHPISubmission();
          }}
        />
      </>
    }
  />

{/* Edit HOPI */}
  <DynamicModal
    ref={editROS}
    modalHeader={`Edit ROS`}
    modalWidth='600px'
    modalBody={
      <>
        {/* <Box display="flex" py="20px">  */}
        <Box display="flex"> 
          <DatePicker
            onDateChange={(selectedDateValue) =>
              handledatechange(selectedDateValue)
            }
            // defaultDate={date}
            defaultDate={editROSData.date}
            disableFutureDates={true}
            placeholderProp="Date"
            calendarStlye={{left: "-18px",  right: "unset"}}
          />
          <PrimaryInput
            variant="bothSide"
            id="vitaltime"
            inputType="time"
            inputPlace="Time"
            pr="10px"
            defaultValue={editROSData.time}
          inputValue={editROSData.time}
            onChange={handleEditTimeChange }
          />
        </Box>
        <Box display="flex" flexDir="column">
          <DropdownInput
            variant="bothSide"
            dropDownPlace="Doctor Name*"
            options={DoctorListForDropdown?DoctorListForDropdown:""}
            id="Doctor Name"
            onClick={HandleEditDoctor}
            // value={DefaultDoctor} 
            // defaultOption={DefaultDoctor}
            value={editROSData.doctorname} 
          defaultOption={editROSData.doctorname}
            menuList={{ pos: "absolute", right: "-41px", minW: "310px" }}
            inputStyleCss={{ w: "100%" }}
          />
        </Box>

        <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
          <Box
            as="form"
            width='100%'
            bg="white"
            pt={"2px"}
          >
            <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
              <Textarea
                borderRadius='0'
                // placeholder="Instructions"
                {...register("textField")}
                inputValue={editROSText}
                // value={updateCC}
                onChange={handleEditTextChange}
                height="100%"
                padding="2"
                resize="none"
                // disabled={typing} // Disable when AI typing is true
                style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
              />
              
              {!editROSText && (
                <Text
                  position="absolute"
                  bottom="2"
                  left="50%"
                  transform="translateX(-50%)"
                  fontSize="sm"
                  color="gray.500"
                  w={{ base: "100%", md: "unset" }}
                  textAlign={{ base: "center", md: "unset" }}
                >
                  {placeholder}
                </Text>
              )}
            </Box>
          </Box>
        </Box>
      </>
    }
    modalFooterBtn={
      <>
      <GPUChatAudioManagerSpeechMode
                  transcriber={activeTranscriber}
                  mode={mode}
                  setPlaceholder={setPlaceholder}
                  setTyping={setTyping}
                />
            <Box
              as="button"
              type="button" // Prevent form submission
              border="1px solid #E6E7E9"
              borderRadius="full"
              w="36px"
              h="auto"
              p="10px"
              mr='10px'
              display="flex"
              justifyContent="center"
              alignItems="center"
              cursor={textFieldValue ? "pointer" : "not-allowed"}
              opacity={textFieldValue ? 1 : 0.5}
              pointerEvents={textFieldValue ? "auto" : "none"}
              onClick={() => textFieldValue && correctOrders("edit")}
            >
              <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
            </Box>
        <PrimaryButton
          // variant="deleteBtn"
          buttonText="Edit ROS"
          btnStyle={{
            w: "100%",
            h: "2.5rem",
          }}
          onClick={handleROSSubmission}
          // onClick={() => {
          //   handleHPISubmission();
          // }}
        />
      </>
    }
  />

{/* Delete ROS */}
<DynamicModal
          ref={deleteModal}
          modalHeader="Delete ROS?"
          modalBody={
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to delete this ROS?
            </Text>
          }
          modalFooterBtn={
            <PrimaryButton
              buttonText="Delete"
              btnStyle={{
                w: "100%",
                h: "2.5rem",
              }}
              onClick={handleConfirmDelete}
            />
          }
        />

          {/* Mobile responsive */}
          <Box w="100%" display={{base: "block", lg: "none"}}>
            <MobileSecondaryNav
              header="Review of system"
              handlebackarrow={backFunction}
            />
            
            <Box h="calc(100vh - 120px)" overflow='hidden auto' p="1rem">
            <Stepper
              orientation="vertical"
              height="100%"
              size="xs"
              colorScheme="#CDCFD4"
              gap="0"
              w="100%"
            >
              {rosData && rosData.length>0 ? (
                  rosData.map((ros,index) => (
                <Step w="100%" >
                  <StepIndicator color="#E6E7E9" />
                  <Box flexShrink="0" w="95%" key={index}>
                    {/* <StepTitle fontSize="0.75rem" fontWeight="500" color="#384052" mb="0.5rem">
                      {ros.DATE ? formatDate(ros.DATE) : ('-')}
                    </StepTitle> */}

                    <StepTitle as="div">
                    <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{formatDate(ros.DATE)}</Text>
                    <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{`${ros.doctorname} , ${ros.bookingid}`}</Text>
                    <Text fontSize="0.875rem" color="#384052" mb="0.5rem">{ros.specialization}</Text>
                  </StepTitle>
                    <StepDescription
                      bg="white"
                      w="100%"
                      border="1px solid #E6E7E9"
                      borderRadius="0.65rem"
                      p="0.75rem"
                      mb="1.5rem"
                      boxShadow="0px 8px 20px 0px #E6E7E966"
                    >
                      <Box w="fit-content" display="flex" flexDir='column' gap="0.5rem" className="textOverflow">
                      <Text fontSize="0.625rem" w="max-content" fontWeight="600" color="#384052" p="0.25rem 0.5rem" bg="#E6E7E966" border="1px solid #E6E7E9" borderRadius="full">
                        {/* Alive */}
                        {ros.rosname}
                      </Text>
                      {ros.rosvalue && ros.rosvalue.length>0 ? (
                        <Box display='flex' flexWrap='wrap' gap='0.5rem'>
                          {ros.rosvalue.map((item,subIndex) => (
                          <Text title={item.value} fontSize="0.875rem" color="#061027" key={subIndex}>
                          {/* A-fib (CMS/HCC) */}
                          {item.value},
                          </Text>
                        ))}
                        </Box>
                      ) : ('-')}
                      </Box>
                    </StepDescription>
                  </Box>

    
                  <StepSeparator colorScheme="red" />
                </Step>
                  ))

              ) : (
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  gap="10px"
                  alignItems="center"
                  h="calc(100vh - 100px)"
                  w="100%"
                >
                  <Box textAlign="left" fontSize="16px" fontWeight="600">
                    <Image
                      w="26px"
                      opacity="0.5"
                      src="/assets/imgs/protection.png"
                    />
                  </Box>
                  <Text textAlign="left" fontSize="12px" fontWeight="500">
                    No Data available
                  </Text>
                </Box>
              )}
            </Stepper>
            </Box>
          </Box>

          
        </>
      );
}

export default ReviewSystem